module.exports = __webpack_public_path__ + "static/media/besins-healthcare-uk-limited.7792d321.jpg";